import React from 'react';
import ConspiracyCard from './ConspiracyCard';
import Shadows from './Shadows';
import PaperScrap from './PaperScrap';
import CARDS from '../data/cards.json';

function Corkboard(props){
    const centralCard = CARDS[0];
    return(
        <div className="corkboard big-board">
            <div className="big-board-container">
                <svg viewBox="0 0 1200 700">
                    <PaperScrap height="140" width="550" x="270" y="15" rotate="3" label="The Rohrabacher Conspiracy" />
                    <Shadows />
                    {CARDS.map(card => {
                        return <ConspiracyCard key={card.label} card={card} selectCard={props.selectCard} centralCard={centralCard} />
                    })}
                <image xlinkHref={require('../images/thumbtack.png')}
                x={centralCard.x + centralCard.width/2 - centralCard.width/10} y={centralCard.y + centralCard.height/150 - centralCard.height/15} height={centralCard.height / 5}  width={centralCard.height/5} /> 
                </svg>
            </div>
        </div>
    )
}

export default Corkboard;


// WEBPACK FOOTER //
// ./src/components/Corkboard.js